import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import decisionService from '../../services/decision.service';

export const addDecision = createAsyncThunk('decisionSlice/addVideo', async (params, thunkAPI) => {
  try {
    const data = await decisionService.addDecisionAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getDecisions = createAsyncThunk('decisionSlice/getDecisions', async (params, thunkAPI) => {
  try {
    const data = await decisionService.getDecisionAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteDecision = createAsyncThunk('decisionSlice/deleteDecision', async (params, thunkAPI) => {
  try {
    const data = await decisionService.deleteDecisionAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getAllCategories = createAsyncThunk('decisionSlice/getAllCategories', async (params, thunkAPI) => {
  try {
    const data = await decisionService.getAllCategoriesAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addToDecision = createAsyncThunk('decisionSlice/addToDecision', async (params, thunkAPI) => {
  try {
    const data = await decisionService.addtoDecisionAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  decisionList: [],
  categoriesList: []
};

const decisionSlice = createSlice({
  name: 'decisionSlice',
  initialState,
  extraReducers: {
    [getDecisions.fulfilled]: (state, action) => {
      state.decisionList = action.payload.data;
    },
    [getAllCategories.fulfilled]: (state, action) => {
      console.log(action.payload.data.results);
      state.categoriesList = action.payload.data.results;
    }
  }
});

const { reducer } = decisionSlice;
export default reducer;
